export const BASE_URL = 'https://intocaerulus.com' // 'http://localhost:3000'
export const PAYMENT_URL = 'https://core.spgateway.com/MPG/mpg_gateway' // https://ccore.spgateway.com/MPG/mpg_gateway'
export const CANCEL_PAYMENT_URL = 'https://core.spgateway.com/API/CreditCard/Cancel' // 'https://ccore.spgateway.com/API/CreditCard/Cancel'
export const CANCEL_PAYMENT_NOTIFY_URL = 'https://us-central1-caerulusvision.cloudfunctions.net/notifyOrderCancelled'
export const MERCHANT_ID = 'MS354833335' // 'MS34207032'
export const MERCHANT_ID_EZPAY = '31722951' // '31722951'

/* Actions */
export const SHOW_LOADING = 'SHOW_LOADING'
export const HIDE_LOADING = 'HIDE_LOADING'
export const SHOW_LOGIN = 'SHOW_LOGIN'
export const HIDE_LOGIN = 'HIDE_LOGIN'
export const SHOW360 = 'SHOW360'
export const HIDE360 = 'HIDE360'
export const SHOW_ALERT = 'SHOW_ALERT'
export const HIDE_ALERT = 'HIDE_ALERT'
export const CHANGE_LANG = 'CHANGE_LANG'
export const CHANGE_CURRENCY = 'CHANGE_CURRENCY'
export const GET_RESOURCES = 'GET_RESOURCES'
export const GET_HOME_RESOURCES = 'GET_HOME_RESOURCES'
export const GET_HOME_SLIDES = 'GET_HOME_SLIDES'
export const GET_HOME_SLIDES_SUCCESS = 'GET_HOME_SLIDES_SUCCESS'
export const GET_HOME_SLIDES_FAILURE = 'GET_HOME_SLIDES_FAILURE'
export const GET_CATEGORIES = 'GET_CATEGORIES'
export const UPDATE_CATEGORIES_STATE = 'UPDATE_CATEGORIES_STATE'
export const INIT_AUTH = 'INIT_AUTH'
export const LOGIN = 'LOGIN'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT = 'LOGOUT'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const TO_REGISTER = 'TO_REGISTER'
export const REGISTER = 'REGISTER'
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD'
export const SEARCH = 'SEARCH'
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT'
export const UPDATE_ACCOUNT_PROFILE_SUCCESS = 'UPDATE_ACCOUNT_PROFILE_SUCCESS'
export const UPDATE_ACCOUNT_ORDERS_SUCCESS = 'UPDATE_ACCOUNT_ORDERS_SUCCESS'
export const UPDATE_ACCOUNT_FAVORITES_SUCCESS = 'UPDATE_ACCOUNT_FAVORITES_SUCCESS'
// Scenes
export const CLOUD_SCENES_IMG_FOLDER = 'images/scenes/'
export const GET_SCENES = 'GET_SCENES'
export const GET_SCENES_SUCCESS = 'GET_SCENES_SUCCESS'
export const GET_SCENES_FAILURE = 'GET_SCENES_FAILURE'
export const SET_VIEW_SCENE = 'SET_VIEW_SCENE'
export const SEARCH_SCENE = 'SEARCH_SCENE'
export const GET_AED_LIST_SUCCESS = 'GET_AED_LIST_SUCCESS'
// Shops
export const CLOUD_SHOPS_IMG_FOLDER = 'images/shops/'
export const GET_SHOPS = 'GET_SHOPS'
export const GET_SHOPS_SUCCESS = 'GET_SHOPS_SUCCESS'
export const GET_SHOPS_FAILURE = 'GET_SHOPS_FAILURE'
export const SET_VIEW_SHOP = 'SET_VIEW_SHOP'
export const SEARCH_SHOP = 'SEARCH_SHOP'
export const ADD_TO_FAVORITE = 'ADD_TO_FAVORITE'
export const REMOVE_FAVORITE = 'REMOVE_FAVORITE'
// Activities
export const CLOUD_ACTIVITIES_IMG_FOLDER = 'images/activities/'
export const GET_ACTIVITIES = 'GET_ACTIVITIES'
export const GET_ACTIVITIES_SUCCESS = 'GET_ACTIVITIES_SUCCESS'
export const GET_ACTIVITIES_FAILURE = 'GET_ACTIVITIES_FAILURE'
export const SEARCH_ACTIVITY = 'SEARCH_ACTIVITY'
export const WRITE_COMMENT = 'WRITE_COMMENT'
export const SEND_COMMENT_SUCCESS = 'SEND_COMMENT_SUCCESS'
export const ADD_ACTIVITY_TO_FAVORITE = 'ADD_ACTIVITY_TO_FAVORITE'
export const REMOVE_ACTIVITY_FROM_FAVORITE = 'REMOVE_ACTIVITY_FROM_FAVORITE'
// Order
export const GET_ORDERS = 'GET_ORDERS'
export const GET_ORDER_BY_ID = 'GET_ORDER_BY_ID'
export const GET_ORDERS_SUCCESS = 'GET_ORDERS_SUCCESS'
export const SET_CURRENT_ORDER = 'SET_CURRENT_ORDER'
export const PLACE_ORDER = 'PLACE_ORDER'
export const UPDATE_ORDER = 'UPDATE_ORDER'
export const CONFIRM_ORDER = 'CONFIRM_ORDER'
export const CANCEL_ORDER = 'CANCEL_ORDER'
// Discounts
export const GET_DISCOUNTS = 'GET_DISCOUNTS'
export const UPDATE_CACHED_DISCOUNTS = 'UPDATE_CACHED_DISCOUNTS'
export const UPDATE_COUPON_STATE = 'UPDATE_COUPON_STATE'
export const GET_ACCOUNT_COUPONS = 'GET_ACCOUNT_COUPONS'
export const UPDATE_CACHED_COUPONS = 'UPDATE_CACHED_COUPONS'
// Announcements
export const GET_ANNOUNCEMENTS = 'GET_ANNOUNCEMENTS'
export const UPDATE_LOCAL_ANNOUNCEMENTS = 'UPDATE_LOCAL_ANNOUNCEMENTS'
// MESSAGE
export const GET_MESSAGES = 'GET_MESSAGES'
export const GET_MESSAGES_SUCCESS = 'GET_MESSAGES_SUCCESS'
export const SEND_MESSAGE = 'SEND_MESSAGE'
export const SHOW_MESSAGE_MODAL = 'SHOW_MESSAGE_MODAL'
export const HIDE_MESSAGE_MODAL = 'HIDE_MESSAGE_MODAL'

/* Enumerations */
export const langs = [
  { label: '繁體中文', value: 'cht' },
  { label: 'ENGLISH', value: 'en' },
]
export const currencies = [
  { label: 'TWD', value: 'twd', ratio: 1 },
  { label: 'USD', value: 'usd', ratio: 0.033705 },
  { label: 'CNY', value: 'cny', ratio: 0.213602631 },
  { label: 'AUD', value: 'aud', ratio: 0.044592417 },
]
export const cardTypes = [
  { label: 'VISA', value: 'visa' },
  { label: 'MASTERCARD', value: 'mastercard' },
]
export const genders = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
]
export const divingExps = [
  { label: 'none', value: 0 },
  { label: 'oneTime', value: 1 },
  { label: 'decadeTimes', value: 11 },
  { label: 'fiftyTimes', value: 51 },
  { label: 'hundredTimes', value: 101 },
]
export const people = [
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 },
  { label: 5, value: 5 },
  { label: 6, value: 6 },
  { label: 7, value: 7 },
]

export const certSystems = [
  { id: "padi", name: "PADI" },
  { id: "ssi", name: "SSI" },
  { id: "sditdi", name: "SDI/TDI" },
  { id: "cmas", name: "CMAS" },
  { id: "ads", name: "ADS" },
  { id: "naui", name: "NAUI" },
  { id: "diwa", name: "DIWA" },
  { id: "others", name: "Others" },
]

export const divingServices = [
  'discoverScubaDiving',
  'diveCourse',
  'freeDiving',
  'techDiving',
  'childrenDiving',
  'shoreDive',
  'boatDive',
  'nitrox',
  'professionalPhotographyDiveGuide',
  'equipmentRental',
  'underwaterCameraRental',
  'diverPropulsionVehicleRental',
  'underwaterPhotographyService',
]

export const otherServices = [
  'accommodations',
  'chineseService',
  'englishService',
  'freeWifi',
  'hotShower',
  'ferryTicketBooking',
  'motorcycleRental',
  'bicycleRental',
  'dining',
  'snorkelling',
  'nightFishing',
  'ecoTours',
  'intertidalZoneNightTourUnchartedSpotExploration'
]


// WEBPACK FOOTER //
// ./src/configs/constants.js